/* eslint-disable @typescript-eslint/no-unnecessary-condition, @typescript-eslint/await-thenable */
import { action, runInAction } from "mobx"
import { AppProvider } from "@providers"

import { AppModels } from "./app.model"

interface Field {
  field: string
  path: string
}

interface Params {
  Providers: AppProvider
  fields?: Field[]
}

export class BaseModel {
  fields: Field[] = []
  protected Providers!: AppProvider
  protected Models!: AppModels

  constructor(params: Params) {
    this.Providers = params.Providers
    if (params.fields && params.fields.length > 0) {
      this.fields = params.fields ?? []
    }
  }

  setModels(models: AppModels) {
    this.Models = models
  }

  action = async (cb: () => void) => {
    if (cb) {
      await runInAction(async () => {
        await cb()
      })
    }
    return
  }

  setField = (field: string) => (value: unknown) => {
    runInAction(() => {
      const f = this.fields.find((fd) => fd.field === field)
      const path = typeof f === "object" ? f.path : ""
      if (path) {
        this[path] = value
      } else {
        // @ts-ignore
        this[field] = value
      }
    })
  }

  applyData = action((data: object) => {
    runInAction(() => {
      Object.entries(data).forEach(([path, value]) => {
        this[path] = value
      })
    })
  })
}
